"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validations_1 = require("./validations");
function addToMean(mean, totalOfElementsInCurrentMean = 0, valueToAdd = 0) {
    if (!(0, validations_1.isNumber)(mean)) {
        return valueToAdd;
    }
    return (mean +
        (valueToAdd - mean) / (totalOfElementsInCurrentMean + 1));
}
exports.default = addToMean;
